import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '../src/assets/global.css';
import axios from "axios";
import echarts from 'echarts'
import VueRouter from "vue-router";
import router from './router';
import store from './store';
Vue.prototype.$axios=axios;
Vue.prototype.$httpUrl='https://zhuoyuan.zhuonamaoyi.com';
Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.use(VueRouter);
new Vue({
  router,
  echarts,
  store,
  render: h => h(App),
}).$mount('#app')
